export const MOBILE = 600;
export const MOBILE_FOOTER = 1400;
export const MOBILE_QUESTION_MARGIN = 8;

export const QUESTION_MARGIN = 20;